import { Divider, Group, ScrollArea, Stack } from '@mantine/core';
import type { ProjectsResponse } from '../../../../../api/projects-client/projects-client.type';
import i18n from '../../../../../base-dictionary';
import { formatMonthDate } from '../../../../../helpers/date-time-helpers';
import { useStrategyStore } from '../../../../../store/strategy-store/strategy-store';
import { baseWhite, inkBase, skyDark } from '../../../../../styles/design-tokens';
import { Button } from '../../../../../ui-library/button/button';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';
import { SideSectionInfoItem } from '../../../initiative-list/side-section/side-section-info-item';
import { getTeamInfo } from './side-section-teams.helpers';

type Props = {
  team: ProjectsResponse | null;
  selectedDate?: Date | null;
  onClickRelatedTasks: () => void;
  onClose: () => void;
};

export const SideSectionTeams = ({ team, selectedDate, onClickRelatedTasks, onClose }: Props) => {
  const initiative = useStrategyStore((state) => state.initiativePerformance);

  if (!team || !initiative) {
    return null;
  }

  return (
    <Stack h="100%">
      <Group justify="space-between">
        <Text weight="bold" size="medium">
          {i18n.t('strategy.initiative_performance.team_details', 'Team Details')}
        </Text>
        <Icon name="close" onClick={onClose} size={20} color={skyDark} aria-label="Close panel" />
      </Group>
      <Divider />
      <Text size="regular" weight="bold" color={inkBase}>
        {team.name}
      </Text>
      <Divider />
      <ScrollArea h="100%" scrollbarSize={0}>
        <Stack gap={8}>
          {selectedDate && (
            <SideSectionInfoItem
              label={i18n.t('strategy.initiative_performance.selected_date', 'Selected Date')}
              value={formatMonthDate(selectedDate)}
            />
          )}
          {getTeamInfo(team as ProjectsResponse, initiative).map((info) => (
            <SideSectionInfoItem key={info.label} label={info.label} value={info.value} />
          ))}
        </Stack>
      </ScrollArea>
      <Button
        variant="secondary"
        size="xs"
        radius="xl"
        fullWidth
        style={{ flexShrink: 0 }}
        leftSection={<Icon name="remove_red_eye" variant="filled" color={baseWhite} size={14} pointer />}
        onClick={onClickRelatedTasks}
      >
        <Text size="small" color={baseWhite}>
          {i18n.t('strategy.initiative_performance.related_tasks.title', 'Related Work Units')}
        </Text>
      </Button>
    </Stack>
  );
};
